import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const Block = ({ b }) => {
  if (b.p) return <p>{b.p}</p>;
  if (b.list)
    return (
      <ul className="space-y-2 pl-1">
        {b.list.map((item, i) => (
          <li key={i} className="flex items-start gap-3">
            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#2E6B50]" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    );
  if (b.fields)
    return (
      <div className="rounded-lg border border-[#D5E2DB] bg-white px-6 py-5">
        <dl className="space-y-2.5">
          {b.fields.map((f, i) => (
            <div key={i} className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
              <dt className="shrink-0 text-xs font-semibold uppercase tracking-[0.12em] text-[#174C3A] sm:w-40 sm:pt-0.5">
                {f.k}
              </dt>
              <dd className="text-[#1A221E]">
                {f.href ? (
                  <a href={f.href} className="underline decoration-[#2E6B50]/40 underline-offset-2 transition-colors duration-300 hover:text-[#174C3A]">
                    {f.v}
                  </a>
                ) : (
                  f.v
                )}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    );
  if (b.cookie)
    return (
      <div className="rounded-lg border border-[#D5E2DB] bg-white p-6">
        <p className="font-mono text-sm font-medium text-[#174C3A]">{b.cookie.name}</p>
        <dl className="mt-4 space-y-2.5">
          {b.cookie.rows.map((f, i) => (
            <div key={i} className="flex flex-col gap-0.5 sm:flex-row sm:gap-3">
              <dt className="shrink-0 text-xs font-semibold uppercase tracking-[0.12em] text-[#2E6B50] sm:w-32 sm:pt-0.5">
                {f.k}
              </dt>
              <dd>{f.v}</dd>
            </div>
          ))}
        </dl>
        {b.cookie.note && <p className="mt-4 border-t border-[#E8F1EC] pt-4 text-sm">{b.cookie.note}</p>}
      </div>
    );
  return null;
};

export const LegalDoc = ({ title, updated, sections, testid }) => (
  <div data-testid={testid}>
    <PageHero
      testid={`${testid}-hero`}
      eyebrow="Documenti legali"
      title={title}
      subtitle={`Ultimo aggiornamento: ${updated}`}
    />
    <section className="bg-[#F8FAF8]">
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 sm:py-20 lg:px-8">
        {sections.map((s, i) => (
          <Reveal key={i}>
            <section data-testid={`${testid}-section-${i + 1}`} className="mb-14 last:mb-0">
              <h2 className="flex items-baseline gap-4 font-serif text-xl font-semibold text-[#0D3327] sm:text-2xl">
                <span className="shrink-0 font-mono text-sm font-medium text-[#2E6B50]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.title}
              </h2>
              <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-[#4B5852] sm:text-base">
                {s.blocks.map((b, j) => (
                  <Block key={j} b={b} />
                ))}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </section>
  </div>
);
